// eslint-disable-next-line import/no-unresolved
import { categoriesMapping, naceCodes } from '@albacross/static-data/lib/nace-codes'

const getLabel = nace => `${nace.section}${nace.code} - ${nace.name}`

const getCode = (nace, categoriesMapping) => (!nace.code ? categoriesMapping[nace.section] : [nace.code])

const getNaceCodeMap = (naceCodes, categoriesMapping) =>
  naceCodes.map(nace => ({
    name: nace.name,
    code: getCode(nace, categoriesMapping).join(';'),
    label: getLabel(nace),
  }))

const getNaceByCode = (value, naceMap) => naceMap.find(code => code.code.replace('.', '') === value.replace('.', ''))

const findNaceCodes = (query, naceMap) => naceMap.filter(code => new RegExp(query, 'i').test(code.label))

const findNace = ({ search, code }: any = {}) => {
  const naceMap = getNaceCodeMap(naceCodes, categoriesMapping)
  return code ? getNaceByCode(code, naceMap) : findNaceCodes(search, naceMap)
}

export const findNaceCode = (query, by = 'code') => (by === 'code' ? findNace({ code: query }) : findNace({ query }))

export const getNaceMap = () =>
  naceCodes.reduce((acc, item) => (acc.has(item.code) ? acc : acc.set(item.code, item)), new Map())
